import { z } from "zod/v4"

/**
 * Organization subject for CASL
 */
export const organizationSubject = z.tuple([
  z.union([
    z.literal("manage"),
    z.literal("get"),
    z.literal("create"),
    z.literal("update"),
    z.literal("delete"),
  ]),
  z.literal("Organization"),
])

export type TOrganizationSubject = z.infer<typeof organizationSubject>

/**
 * Member subject for CASL
 */
export const memberSubject = z.tuple([
  z.union([
    z.literal("manage"),
    z.literal("get"),
    z.literal("create"),
    z.literal("update"),
    z.literal("delete"),
  ]),
  z.literal("Member"),
])

export type TMemberSubject = z.infer<typeof memberSubject>

/**
 * People subject for CASL (matches backend "People")
 */
export const peopleSubject = z.tuple([
  z.union([
    z.literal("manage"),
    z.literal("get"),
    z.literal("create"),
    z.literal("update"),
    z.literal("delete"),
  ]),
  z.literal("People"),
])

export type TPeopleSubject = z.infer<typeof peopleSubject>

/**
 * FinanceAccount subject for CASL
 */
export const financeAccountSubject = z.tuple([
  z.union([
    z.literal("manage"),
    z.literal("create"),
    z.literal("get"),
    z.literal("delete"),
  ]),
  z.literal("FinanceAccount"),
])

export type TFinanceAccountSubject = z.infer<typeof financeAccountSubject>

/**
 * FinanceCategory subject for CASL
 */
export const financeCategorySubject = z.tuple([
  z.union([
    z.literal("manage"),
    z.literal("create"),
    z.literal("get"),
    z.literal("delete"),
  ]),
  z.literal("FinanceCategory"),
])

export type TFinanceCategorySubject = z.infer<typeof financeCategorySubject>

/**
 * User subject for CASL (organization context)
 */
export const organizationUserSubject = z.tuple([
  z.union([
    z.literal("manage"),
    z.literal("get"),
    z.literal("create"),
    z.literal("update"),
    z.literal("delete"),
  ]),
  z.literal("User"),
])

export type TOrganizationUserSubject = z.infer<typeof organizationUserSubject>

/**
 * ApiKey subject for CASL
 */
export const apiKeySubject = z.tuple([
  z.union([
    z.literal("manage"),
    z.literal("get"),
    z.literal("create"),
    z.literal("revoke"),
  ]),
  z.literal("ApiKey"),
])

export type TApiKeySubject = z.infer<typeof apiKeySubject>
